module.exports = __webpack_public_path__ + "static/media/residential.c38314f7.jpeg";